<template>
  <div>
    <el-button
      v-if="isNotEdit"
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-edit"
      @click="clickEditBtn()"
      >编辑</el-button
    >
    <el-button
      v-if="isNotEdit == false"
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-close"
      @click="clickCancelEditBtn()"
      >取消</el-button
    >
    <el-button
      v-if="isNotEdit == false"
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-check"
      @click="updateSystemConfig()"
      >保存</el-button
    >
    <el-tooltip style="margin-left: 15px" effect="dark" placement="top">
      <div slot="content">
        示例：<br />
        1. int类型表达式：  &emsp;&emsp;"test_int": {"$numberInt": "32"}<br />
        2. long类型表达式：  &emsp;"test_long": {"$numberLong": "64"}<br />
        3. double类型表达式："test_double": {"$numberDouble": "1.0"}<br />
        4. date类型表达式：  &emsp;"test_date": {"$date": {"$numberLong": "13000"}}<br />
      </div>
      <span style="font-size: 1.5rem"><i class="el-icon-question"></i></span>
    </el-tooltip>
    <el-form
      ref="form"
      class="json-text"
      label-width="0px"
      size="mini"
      style="width: 950px; height: 550px"
    >
      <el-form-item label="" prop="parmeter1">
        <el-input
          v-model="systemConfigText"
          :disabled="isNotEdit"
          type="textarea"
          :rows="30"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      isNotEdit: true,
      systemConfig: {},
      systemConfigText: "",
    };
  },

  async created() {
    // 拉取渠道集合
    await this.loadSystemConfig();
  },

  components: {},

  methods: {
    /**
     * 加载系统设置
     */
    async loadSystemConfig() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getSystemConfig`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }
      this.systemConfig = resData.data || {};
      let tmpObj  = JSON.parse(this.systemConfig.config)
      this.systemConfigText = JSON.stringify(tmpObj, null, "    ");
    },
    /**
     * 点击按钮编辑按钮
     */
    clickEditBtn() {
      this.isNotEdit = false;
    },
    /**
     * 点击按钮取消编辑按钮
     */
    clickCancelEditBtn() {
      this.isNotEdit = true;
      let tmpObj  = JSON.parse(this.systemConfig.config)
      this.systemConfigText = JSON.stringify(tmpObj, null, "    ");
    },
    /**
     * 修改系统配置
     */
    async updateSystemConfig() {
      try {
        this.systemConfig.config = this.systemConfigText;
      } catch (e) {
        this.$message({
          message: e,
          type: "error",
        });
      }

      try {
        // 弹确认框
        await this.$confirm(`确认修改？`);
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateSystemConfig`,
            this.systemConfig,
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        this.isNotEdit = true;
  
        let tmpObj  = JSON.parse(this.systemConfig.config)
        this.systemConfigText = JSON.stringify(tmpObj, null, "    ");
      } catch (e) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.env-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 2px;
}

.env-tag-test {
  border: 2px solid lightgray;
}

.env-tag-stage {
  border: 2px solid red;
}

.env-tag-prod {
  border: 2px solid chartreuse;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: #FFF;
    border-color: #E4E7ED;
    color: #000000;
    cursor: not-allowed;
}
</style>